import React, { useContext, useEffect, useState } from "react";
import { PlantsContext } from "../context/PlantsContext";
// import ReactFancyBox from "react-fancybox";
// import "react-fancybox/lib/fancybox.css";

import { MdBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Fancybox from "../components/plates/Fancybox";
import Slider from "react-slick";
import useIsLargeScreen from "../utils/useIsLargeScreen";
import SideBar from "../components/menu/SideBar";
import BackBtn from "../components/menu/BackBtn";
import { BsVectorPen } from "react-icons/bs";
import { VersionContext } from "../context/VersionContext";
import BackBtnLarge from "../components/menu/BackBtnLarge";

const Plates = () => {
  const { getAllPlants, plates } = useContext(PlantsContext);
  const { version } = useContext(VersionContext);

  const [isLoaded, setIsLoaded] = useState(false);
  const isLargeScreen = useIsLargeScreen();
  const handleImageLoad = () => {
    setIsLoaded(true);
  };
  useEffect(() => {
    version();
  }, []);
  useEffect(() => {
    getAllPlants();
    // setPlates(filterPlates);
  }, []);

  const navigate = useNavigate();
  const backToMap = () => {
    navigate("/map");
  };
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    // vertical: true,
    // verticalSwiping: true,
    swipeToSlide: true,
    // beforeChange: function (currentSlide, nextSlide) {
    //   console.log("before change", currentSlide, nextSlide);
    // },
    // afterChange: function (currentSlide) {
    //   console.log("after change", currentSlide);
    // },
  };
  console.log("e1", plates);
  return (
    <div className=''>
      {isLargeScreen && <SideBar />}
      <section className='section-page blue-background section-full-page section-users section-large section-plates page-large-container min-100'>
        <BackBtn />
        {isLargeScreen && <BackBtnLarge />}
        <div className='section-center '>
          <section className='section-page'>
            <div className='menu-section-center'>
              <h2 className='section-title pt-4'>Le vostre targhe</h2>
              <article className='mb-5 plate-info'>
                <p className='mb-0'>
                  Sulle vostre piantine applichiamo una targa in{" "}
                  <span className='cl-brown fw-bold'>alluminio</span> avente
                  come <span className='cl-brown fw-bold'>sfondo</span> il
                  quadro di{" "}
                  <span className='cl-brown fw-bold'>Ernest Verner</span>.
                </p>
                <p className='mb-0'>
                  Tutte le vostre targhe sono presentate nella{" "}
                  <i className='cl-brown'>galleria targhe</i> di Ti pianto per
                  amore.
                </p>
              </article>
              <span className='mb-3 h5 d-flex flex-row align-items-center position-relative'>
                <div className='step-title pe-1'>
                  <BsVectorPen />
                </div>
                <span className='fst-italic font-plate'>Galleria targhe</span>
                <div className='ink-gallery'></div>
              </span>
              {plates?.length === 0 && (
                <p>Non ci sono targhe da visualizzare.</p>
              )}
              {plates?.length === 1 && (
                <img
                  onLoad={handleImageLoad}
                  className={`plates-img transition-opacity duration-500 ${
                    isLoaded ? "opacity-100" : "opacity-0"
                  }`}
                  alt=''
                  src={plates[0].plate}
                />
              )}
              {plates?.length > 1 && (
                <Fancybox>
                  <div className='slider-container'>
                    <Slider {...settings}>
                      {plates.map((e, index) => {
                        return (
                          <a data-fancybox='gallery' href={e.plate} key={index}>
                            {/* <div
                              className='slide-plate'
                              style={{
                                backgroundImage: `url(${e.plate})`,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                objectFit: "cover",
                              }}
                            ></div> */}
                            <img
                              className='plate-img transition-opacity duration-500 ${
                                isLoaded ? "opacity-100" : "opacity-0'
                              onLoad={handleImageLoad}
                              alt=''
                              src={e.plate}
                            />
                          </a>
                        );
                      })}
                    </Slider>
                  </div>
                </Fancybox>
              )}
              {/* <ReactFancyBox
              thumbnail='https://loremflickr.com/320/240'
              image='https://www.w3schools.com/howto/img_forest.jpg'
            /> */}
            </div>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Plates;
